/**
 * Created by spepa on 19.12.2024
 */

const TelegramPayments = function () {
    Payments.call(this, connector.TELEGRAM, {
        sdk: SdkManager.SDK_TELEGRAM
    });
};

TelegramPayments.prototype = Object.create(RestPayments.prototype);
TelegramPayments.prototype.constructor = TelegramPayments;

TelegramPayments.prototype.getDefaultCurrency = function () {
    return "XTR";
};

TelegramPayments.prototype.getProductId = function (product) {
    return product.id.telegram;
};

TelegramPayments.prototype.getTextPrice = function (price) {
    return `${connector.utils.formatAmount(price)} XTR`;
};

TelegramPayments.prototype.purchase = function (product, callback, payload) {
    ConnectorRestClient.post("/telegram/pay", {
        productId: product.productId,
        title: product.title,
        description: product.description,
        image: product.image,
        price: this.getPriceToBePaid(product)
    }, (response) => {
        if (response.error) {
            console.error(response.error);
            this.bus.trigger("stream:error", `TelegramPayments.purchase productId: ${product.productId} ${JSON.stringify(response.error)}`);
            callback(ERRORS.PURCHASE.UNKNOWN);
            return;
        }

        console.log(`TelegramPayments invoice created: ${response.invoiceUrl}`);

        try {
            window.Telegram.WebApp.openInvoice(response.invoiceUrl, (result) => {
                if (result === "paid") {
                    // TODO: consume purchase from server (and maybe wait for successful_payment event)
                    const purchase = this.createPurchase(undefined, product, payload);
                    console.log("TelegramPayments.purchase", JSON.stringify(purchase));

                    callback(connector.CODE_SUCCEED, purchase);
                } else if (result === "cancelled") {
                    callback(ERRORS.PURCHASE.CANCEL);
                } else { // "failed" or "pending"
                    callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: result });
                }
            });
        } catch (e) {
            console.error(e);
            callback(connector.CODE_FAILED);
        }
    }, (error) => {
        console.error(error);
        callback(connector.CODE_FAILED);
    });
};

TelegramPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.TELEGRAM);
};